import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Loader, LoginForm, RegisterForm, FormRenderer, AvailabilitiesField } from '..';
import { startWorkflow, getBrickResources, doneBrick } from '../../redux';

import './WorkflowRunner.css';

const WorkflowRunner = ({ workflow_id, tkt_instance_id }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { workflow, isLoading, errorMessage } = useSelector(state => state.workflows);

    const [done, setDone] = useState({});

    useEffect(() => {
        if (!workflow_id || !tkt_instance_id)
            return;

        if (workflow?.id !== workflow_id) {
            dispatch(startWorkflow(workflow_id, tkt_instance_id));
        }
    }, [workflow_id, tkt_instance_id]);

    const onDone = (context, callback) => {
        setDone({
            ...done,
            [brickIndex]: true
        });

        if (done[brickIndex])
            return;

        dispatch(doneBrick(
            workflow.id,
            workflow.tkt_instance_id,
            context,
            (err, workflow) => {
                callback && callback(err, workflow);
            }
        ));
    }

    const brickIndex = workflow?.getCurrentBrickIndex();
    const brick = workflow?.getCurrentBrick();

    useEffect(() => {
        if (brick && !brick?.resources)
            dispatch(getBrickResources(
                workflow.id,
                workflow.tkt_instance_id,
                brick.id
            ));
    }, [brick]);

    if (!workflow || isLoading)
        return (
            <div className="loader-wrapper center light">
                <Loader color="#454545" />
            </div>
        );

    const context = workflow.context || {};
    const errors = workflow.getErrors();
    const messages = workflow.getMessages();

    if (workflow.succeeded())
        return <div className="text-success">Done</div>;

    if (workflow.failed())
        return (
            <div className="alert alert-danger">
                {errors.map((error, index) => (
                    <span key={index} dangerouslySetInnerHTML={{__html: error}}></span>
                ))}
            </div>
        );

    if (!workflow?.bricks?.length)
        return null;

    if (!brick || brick.server_side)
        return null;

    return (
        <div className="WorkflowRunner">
            {errorMessage && (
                <div className="alert alert-danger">
                    <span dangerouslySetInnerHTML={{__html: errorMessage}}></span>
                </div>
            )}
            {messages?.map((message, index) => (
                <div key={index} className="bg-success p-3 text-white">
                    <span dangerouslySetInnerHTML={{__html: message}}></span>
                </div>
            ))}
            { brick.run(context, onDone) }
        </div>
    );
}

export default WorkflowRunner;

